import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Login from './components/Login';
import MediaListPage from './pages/MediaListPage';
import HomePage from './pages/HomePage';
import AddMediaPage from './pages/AddMediaPage';
import RecommendationsPage from './pages/RecommendationsPage';
import MediaTypeOverviewPage from './pages/MediaTypeOverviewPage';
import MediaItemPage from './pages/MediaItemPage';
import Register from './components/Register';
import CustomBackground from './components/CustomBackground';
import AdminPage from './pages/AdminPage';
import SecretPage from './pages/SecretPage';
import NewsFeedPage from './pages/NewsFeedPage';
import ApiUsagePage from './pages/ApiUsagePage';
import AboutPage from './pages/AboutPage';
import CustomBackgroundPage from './pages/CustomBackgroundPage';

import './styles/App.css';


function App() {
  const apiBaseUrl = 'https://y02.nl/api'
  // const apiBaseUrl = 'http://192.168.178.47:5000/api' 

  return (
    <AuthProvider apiBaseUrl={apiBaseUrl}>
      <Router>
        <div className="App">
          <Navbar apiBaseUrl={apiBaseUrl} />
          <main>

          <Routes>
            <Route path="/" element={<HomePage apiBaseUrl={apiBaseUrl} />} />
            <Route path="/media-list/:mediaType" element={<MediaListPage apiBaseUrl={apiBaseUrl} />} />
            <Route path="/add-media" element={<AddMediaPage apiBaseUrl={apiBaseUrl} />} />
            <Route path="/overview" element={<MediaTypeOverviewPage apiBaseUrl={apiBaseUrl} />} />
            <Route path="/admin" element={<AdminPage apiBaseUrl={apiBaseUrl} />} />
            <Route path="/secret" element={<SecretPage apiBaseUrl={apiBaseUrl} />} />
            <Route path="/login" element={<Login apiBaseUrl={apiBaseUrl} />} />
            <Route path="/recommendations" element={<RecommendationsPage apiBaseUrl={apiBaseUrl} />} />
            <Route path="/media-item/:mediaId" element={<MediaItemPage apiBaseUrl={apiBaseUrl} />} />
            <Route path="/register/:token" element={<Register apiBaseUrl={apiBaseUrl} />} />
            <Route path="/activityfeed" element={<NewsFeedPage apiBaseUrl={apiBaseUrl} />} />
            <Route path="/api-usage" element={<ApiUsagePage apiBaseUrl={apiBaseUrl} />} />
            <Route path="/about" element={<AboutPage apiBaseUrl={apiBaseUrl} />} />
            <Route path="/background" element={<CustomBackgroundPage apiBaseUrl={apiBaseUrl} />} />

          </Routes>
          </main>
          <Footer/>
          <CustomBackground />
       </div>
      </Router>
    </AuthProvider>
  );
}

export default App;